// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"806d4fee","186":"e4a26760","344":"573bbe4e","372":"15724b2e","377":"6ef7809a","630":"9cdaebf8","841":"297a4c62","851":"9ab8d3f8","856":"6a77890e","858":"936b63e6"}[chunkId] + ".chunk.js";
};